import { FormGroup, Validators } from "@angular/forms";

export function addRequiredRuleWhenValueChange(form: FormGroup, formWithRequiredFields: FormGroup, fieldName: string) {
  form.get(fieldName)?.valueChanges.subscribe((checked: boolean) => {
    if (!checked) {
      Object.keys(formWithRequiredFields.controls).forEach((key) => {
        formWithRequiredFields.get(key)?.setValidators(Validators.required);
        formWithRequiredFields.get(key)?.updateValueAndValidity();
      });
    } else {
      Object.keys(formWithRequiredFields.controls).forEach((key) => {
        formWithRequiredFields.get(key)?.clearValidators();
        formWithRequiredFields.get(key)?.updateValueAndValidity();
      });
    }
  });
}

export function checkRequiredError(form: FormGroup): boolean {
  return Object.keys(form.controls).some((key) => {
    const control = form.get(key);
    return control && control.errors?.["required"] && control.touched;
  });
}

export function checkFieldError(form: FormGroup, field: string, error: string) {
  return form.get(field)?.errors?.[error];
}

export function isInvalidField(form: FormGroup, field: string) {
  return form.get(field)?.invalid && form.get(field)?.touched;
}

export function getFormControlValue(form: FormGroup, controlName: string) {
  return form.controls[controlName].value;
}

export function downloadBlob(blob: Blob, filename: string): void {
  const url = window.URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();

  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}
